import Select, { OptionProps, components } from "react-select";

import PropTypes from "prop-types";
import React from "react";
import chroma from "chroma-js";

export const colorOption = [
    { label: "#7e8eda", value: 0 },
    { label: "#6478d7", value: 1 },
    { label: "#556ee6", value: 2 },
    { label: "#4362f8", value: 3 },
    { label: "#999bb4", value: 4 },
  ];
function SelectColor(props) {
  const dot = (color = "transparent") => ({
    alignItems: "center",
    display: "flex",
    backgroundColor: color,
    color: color,
  });
  const selectOption = {
    control: styles => ({ ...styles, backgroundColor: "white" }),
    input: styles => ({ ...styles, ...dot() }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma(data.label);
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? data.color
          : isFocused
          ? color.alpha(0.1).css()
          : undefined,
        color: data.label,
        cursor: isDisabled ? "not-allowed" : "default",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? data.color
              : color.alpha(0.3).css()
            : undefined,
        },
      };
    },

    singleValue: (styles, { data }) => ({ ...styles, ...dot(data.label) }),
    // singleValue: (styles, { data }) => console.log(data),
  };
  
  const ColorOption = ({ children, ...props }:OptionProps) => {
    return (
      <components.Option {...props}>
       <div style={{backgroundColor:children,width:"100%",height:"20px"}}></div>
      </components.Option>
    );
  };
  return (
    <Select
      {...props}
      classNamePrefix="select2-selection"
      onChange={selected => props.onChange(selected)}
      defaultValue={colorOption[0]}
      styles={selectOption}
      options={colorOption}
      components={{ Option: ColorOption }}
    />
  );
}
SelectColor.propTypes = {
  onChange: PropTypes.any,
};

export default SelectColor;

